/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getProjects = /* GraphQL */ `
  query GetProjects($type: String!) {
    getProjects(type: $type) {
      id
      creator {
        id
        username
        dateOfBirth
        email
        subscribedToEmails
        phone
        age
        avatarName
        bio
        hasConnectedImagiCharm
        reported
        participatedIn30DayChallenge
        lastCompletedEpisode
        specialBadges
        specialUserAttributes {
          id
          name
          dateReceived
          isFrame
          type
          seen
        }
        notificationToken
        creationDate
        lastNotificationSeen
        tipsSeen {
          id
          name
          dateSeen
        }
        isInternalUser
        firstConnectedToImagiCharm
        lastConnectedToImagiCharm
        commentsPosted
        tryCount
        sharedProjectsCount
        tryCodeCount
        episodeCodes {
          title
          code
        }
        firmwareVersion
      }
      background
      border
      comments {
        id
        creator {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        text
        reported
        creationDate
      }
      likes {
        id
        liker {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        creationDate
      }
      tries {
        id
        trier {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        creationDate
      }
      tags
      frames {
        id
        colors
        duration
      }
      plainFrames
      displayColors
      creationDate
      projectCode
      type
      searchData
      privateTitle
      sharedToHome
      reported
      username
      avatarName
      owner
      categoryLevel
      category
      level
      tryCount
      isAnimation
      isFeatured
      isAnimationLevel
      isFeaturedLevel
      createdFromWebApp
      updatedFromWebApp
    }
  }
`;
export const getProject = /* GraphQL */ `
  query GetProject($id: ID!, $type: String!) {
    getProject(id: $id, type: $type) {
      id
      creator {
        id
        username
        dateOfBirth
        email
        subscribedToEmails
        phone
        age
        avatarName
        bio
        hasConnectedImagiCharm
        reported
        participatedIn30DayChallenge
        lastCompletedEpisode
        specialBadges
        specialUserAttributes {
          id
          name
          dateReceived
          isFrame
          type
          seen
        }
        notificationToken
        creationDate
        lastNotificationSeen
        tipsSeen {
          id
          name
          dateSeen
        }
        isInternalUser
        firstConnectedToImagiCharm
        lastConnectedToImagiCharm
        commentsPosted
        tryCount
        sharedProjectsCount
        tryCodeCount
        episodeCodes {
          title
          code
        }
        firmwareVersion
      }
      background
      border
      comments {
        id
        creator {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        text
        reported
        creationDate
      }
      likes {
        id
        liker {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        creationDate
      }
      tries {
        id
        trier {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        creationDate
      }
      tags
      frames {
        id
        colors
        duration
      }
      plainFrames
      displayColors
      creationDate
      projectCode
      type
      searchData
      privateTitle
      sharedToHome
      reported
      username
      avatarName
      owner
      categoryLevel
      category
      level
      tryCount
      isAnimation
      isFeatured
      isAnimationLevel
      isFeaturedLevel
      createdFromWebApp
      updatedFromWebApp
    }
  }
`;
export const getPrivateProjects = /* GraphQL */ `
  query GetPrivateProjects($type: String!) {
    getPrivateProjects(type: $type) {
      id
      creator {
        id
        username
        dateOfBirth
        email
        subscribedToEmails
        phone
        age
        avatarName
        bio
        hasConnectedImagiCharm
        reported
        participatedIn30DayChallenge
        lastCompletedEpisode
        specialBadges
        specialUserAttributes {
          id
          name
          dateReceived
          isFrame
          type
          seen
        }
        notificationToken
        creationDate
        lastNotificationSeen
        tipsSeen {
          id
          name
          dateSeen
        }
        isInternalUser
        firstConnectedToImagiCharm
        lastConnectedToImagiCharm
        commentsPosted
        tryCount
        sharedProjectsCount
        tryCodeCount
        episodeCodes {
          title
          code
        }
        firmwareVersion
      }
      background
      border
      comments {
        id
        creator {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        text
        reported
        creationDate
      }
      likes {
        id
        liker {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        creationDate
      }
      tries {
        id
        trier {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        creationDate
      }
      tags
      frames {
        id
        colors
        duration
      }
      plainFrames
      displayColors
      creationDate
      projectCode
      type
      searchData
      privateTitle
      sharedToHome
      reported
      username
      avatarName
      owner
      categoryLevel
      category
      level
      tryCount
      isAnimation
      isFeatured
      isAnimationLevel
      isFeaturedLevel
      createdFromWebApp
      updatedFromWebApp
    }
  }
`;
export const adminGetPrivateProjects = /* GraphQL */ `
  query AdminGetPrivateProjects($type: String!, $user_id: String!) {
    adminGetPrivateProjects(type: $type, user_id: $user_id) {
      id
      creator {
        id
        username
        dateOfBirth
        email
        subscribedToEmails
        phone
        age
        avatarName
        bio
        hasConnectedImagiCharm
        reported
        participatedIn30DayChallenge
        lastCompletedEpisode
        specialBadges
        specialUserAttributes {
          id
          name
          dateReceived
          isFrame
          type
          seen
        }
        notificationToken
        creationDate
        lastNotificationSeen
        tipsSeen {
          id
          name
          dateSeen
        }
        isInternalUser
        firstConnectedToImagiCharm
        lastConnectedToImagiCharm
        commentsPosted
        tryCount
        sharedProjectsCount
        tryCodeCount
        episodeCodes {
          title
          code
        }
        firmwareVersion
      }
      background
      border
      comments {
        id
        creator {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        text
        reported
        creationDate
      }
      likes {
        id
        liker {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        creationDate
      }
      tries {
        id
        trier {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        creationDate
      }
      tags
      frames {
        id
        colors
        duration
      }
      plainFrames
      displayColors
      creationDate
      projectCode
      type
      searchData
      privateTitle
      sharedToHome
      reported
      username
      avatarName
      owner
      categoryLevel
      category
      level
      tryCount
      isAnimation
      isFeatured
      isAnimationLevel
      isFeaturedLevel
      createdFromWebApp
      updatedFromWebApp
    }
  }
`;
export const listProjects = /* GraphQL */ `
  query ListProjects(
    $filter: TableProjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProjects(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        creator {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        background
        border
        comments {
          id
          creator {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          text
          reported
          creationDate
        }
        likes {
          id
          liker {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tries {
          id
          trier {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tags
        frames {
          id
          colors
          duration
        }
        plainFrames
        displayColors
        creationDate
        projectCode
        type
        searchData
        privateTitle
        sharedToHome
        reported
        username
        avatarName
        owner
        categoryLevel
        category
        level
        tryCount
        isAnimation
        isFeatured
        isAnimationLevel
        isFeaturedLevel
        createdFromWebApp
        updatedFromWebApp
      }
      nextToken
    }
  }
`;
export const listProjects2 = /* GraphQL */ `
  query ListProjects2(
    $filter: TableProjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProjects2(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        creator {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        background
        border
        comments {
          id
          creator {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          text
          reported
          creationDate
        }
        likes {
          id
          liker {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tries {
          id
          trier {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tags
        frames {
          id
          colors
          duration
        }
        plainFrames
        displayColors
        creationDate
        projectCode
        type
        searchData
        privateTitle
        sharedToHome
        reported
        username
        avatarName
        owner
        categoryLevel
        category
        level
        tryCount
        isAnimation
        isFeatured
        isAnimationLevel
        isFeaturedLevel
        createdFromWebApp
        updatedFromWebApp
      }
      nextToken
    }
  }
`;
export const listUserProjects = /* GraphQL */ `
  query ListUserProjects(
    $creator: ID
    $filter: TableProjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserProjects(
      creator: $creator
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        creator {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        background
        border
        comments {
          id
          creator {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          text
          reported
          creationDate
        }
        likes {
          id
          liker {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tries {
          id
          trier {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tags
        frames {
          id
          colors
          duration
        }
        plainFrames
        displayColors
        creationDate
        projectCode
        type
        searchData
        privateTitle
        sharedToHome
        reported
        username
        avatarName
        owner
        categoryLevel
        category
        level
        tryCount
        isAnimation
        isFeatured
        isAnimationLevel
        isFeaturedLevel
        createdFromWebApp
        updatedFromWebApp
      }
      nextToken
    }
  }
`;
export const listWebPrivateProjects = /* GraphQL */ `
  query ListWebPrivateProjects(
    $creator: ID
    $filter: TableProjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWebPrivateProjects(
      creator: $creator
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        creationDate
        privateTitle
        projectCode
        type
      }
      nextToken
    }
  }
`;
export const listNotifications = /* GraphQL */ `
  query ListNotifications($recipient: ID) {
    listNotifications(recipient: $recipient) {
      id
      recipient
      type
      creationDate
      read
      linkedProject
      linkedComment
      linkedUserId
      linkedUsername
      text
      avatar
      link
    }
  }
`;
export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      username
      dateOfBirth
      email
      subscribedToEmails
      phone
      age
      avatarName
      bio
      hasConnectedImagiCharm
      reported
      participatedIn30DayChallenge
      lastCompletedEpisode
      specialBadges
      specialUserAttributes {
        id
        name
        dateReceived
        isFrame
        type
        seen
      }
      notificationToken
      creationDate
      lastNotificationSeen
      tipsSeen {
        id
        name
        dateSeen
      }
      isInternalUser
      firstConnectedToImagiCharm
      lastConnectedToImagiCharm
      commentsPosted
      tryCount
      sharedProjectsCount
      tryCodeCount
      episodeCodes {
        title
        code
      }
      firmwareVersion
    }
  }
`;
export const getExternalUser = /* GraphQL */ `
  query GetExternalUser($id: ID!) {
    getExternalUser(id: $id) {
      id
      username
      dateOfBirth
      email
      subscribedToEmails
      phone
      age
      avatarName
      bio
      hasConnectedImagiCharm
      reported
      participatedIn30DayChallenge
      lastCompletedEpisode
      specialBadges
      specialUserAttributes {
        id
        name
        dateReceived
        isFrame
        type
        seen
      }
      notificationToken
      creationDate
      lastNotificationSeen
      tipsSeen {
        id
        name
        dateSeen
      }
      isInternalUser
      firstConnectedToImagiCharm
      lastConnectedToImagiCharm
      commentsPosted
      tryCount
      sharedProjectsCount
      tryCodeCount
      episodeCodes {
        title
        code
      }
      firmwareVersion
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: TableUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        username
        dateOfBirth
        email
        subscribedToEmails
        phone
        age
        avatarName
        bio
        hasConnectedImagiCharm
        reported
        participatedIn30DayChallenge
        lastCompletedEpisode
        specialBadges
        specialUserAttributes {
          id
          name
          dateReceived
          isFrame
          type
          seen
        }
        notificationToken
        creationDate
        lastNotificationSeen
        tipsSeen {
          id
          name
          dateSeen
        }
        isInternalUser
        firstConnectedToImagiCharm
        lastConnectedToImagiCharm
        commentsPosted
        tryCount
        sharedProjectsCount
        tryCodeCount
        episodeCodes {
          title
          code
        }
        firmwareVersion
      }
      nextToken
    }
  }
`;
export const listTutorials = /* GraphQL */ `
  query ListTutorials {
    listTutorials {
      items {
        id
        title
        steps
      }
      nextToken
    }
  }
`;
export const getTutorial = /* GraphQL */ `
  query GetTutorial($id: ID!) {
    getTutorial(id: $id) {
      id
      title
      steps
    }
  }
`;
export const userIsAdmin = /* GraphQL */ `
  query UserIsAdmin {
    userIsAdmin
  }
`;
export const listProjectsByCategory = /* GraphQL */ `
  query ListProjectsByCategory(
    $category: String
    $filter: TableProjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProjectsByCategory(
      category: $category
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        creator {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        background
        border
        comments {
          id
          creator {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          text
          reported
          creationDate
        }
        likes {
          id
          liker {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tries {
          id
          trier {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tags
        frames {
          id
          colors
          duration
        }
        plainFrames
        displayColors
        creationDate
        projectCode
        type
        searchData
        privateTitle
        sharedToHome
        reported
        username
        avatarName
        owner
        categoryLevel
        category
        level
        tryCount
        isAnimation
        isFeatured
        isAnimationLevel
        isFeaturedLevel
        createdFromWebApp
        updatedFromWebApp
      }
      nextToken
    }
  }
`;
export const listProjectsByCategoryOldestFirst = /* GraphQL */ `
  query ListProjectsByCategoryOldestFirst(
    $category: String
    $filter: TableProjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProjectsByCategoryOldestFirst(
      category: $category
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        creator {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        background
        border
        comments {
          id
          creator {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          text
          reported
          creationDate
        }
        likes {
          id
          liker {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tries {
          id
          trier {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tags
        frames {
          id
          colors
          duration
        }
        plainFrames
        displayColors
        creationDate
        projectCode
        type
        searchData
        privateTitle
        sharedToHome
        reported
        username
        avatarName
        owner
        categoryLevel
        category
        level
        tryCount
        isAnimation
        isFeatured
        isAnimationLevel
        isFeaturedLevel
        createdFromWebApp
        updatedFromWebApp
      }
      nextToken
    }
  }
`;
export const listProjectsByCategoryMostTriedFirst = /* GraphQL */ `
  query ListProjectsByCategoryMostTriedFirst(
    $category: String
    $filter: TableProjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProjectsByCategoryMostTriedFirst(
      category: $category
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        creator {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        background
        border
        comments {
          id
          creator {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          text
          reported
          creationDate
        }
        likes {
          id
          liker {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tries {
          id
          trier {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tags
        frames {
          id
          colors
          duration
        }
        plainFrames
        displayColors
        creationDate
        projectCode
        type
        searchData
        privateTitle
        sharedToHome
        reported
        username
        avatarName
        owner
        categoryLevel
        category
        level
        tryCount
        isAnimation
        isFeatured
        isAnimationLevel
        isFeaturedLevel
        createdFromWebApp
        updatedFromWebApp
      }
      nextToken
    }
  }
`;
export const listProjectsOldestFirst = /* GraphQL */ `
  query ListProjectsOldestFirst(
    $filter: TableProjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProjectsOldestFirst(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        creator {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        background
        border
        comments {
          id
          creator {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          text
          reported
          creationDate
        }
        likes {
          id
          liker {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tries {
          id
          trier {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tags
        frames {
          id
          colors
          duration
        }
        plainFrames
        displayColors
        creationDate
        projectCode
        type
        searchData
        privateTitle
        sharedToHome
        reported
        username
        avatarName
        owner
        categoryLevel
        category
        level
        tryCount
        isAnimation
        isFeatured
        isAnimationLevel
        isFeaturedLevel
        createdFromWebApp
        updatedFromWebApp
      }
      nextToken
    }
  }
`;
export const listProjectsMostTriedFirst = /* GraphQL */ `
  query ListProjectsMostTriedFirst(
    $filter: TableProjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProjectsMostTriedFirst(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        creator {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        background
        border
        comments {
          id
          creator {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          text
          reported
          creationDate
        }
        likes {
          id
          liker {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tries {
          id
          trier {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tags
        frames {
          id
          colors
          duration
        }
        plainFrames
        displayColors
        creationDate
        projectCode
        type
        searchData
        privateTitle
        sharedToHome
        reported
        username
        avatarName
        owner
        categoryLevel
        category
        level
        tryCount
        isAnimation
        isFeatured
        isAnimationLevel
        isFeaturedLevel
        createdFromWebApp
        updatedFromWebApp
      }
      nextToken
    }
  }
`;
export const listProjectsByLevel = /* GraphQL */ `
  query ListProjectsByLevel(
    $level: Int
    $filter: TableProjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProjectsByLevel(
      level: $level
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        creator {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        background
        border
        comments {
          id
          creator {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          text
          reported
          creationDate
        }
        likes {
          id
          liker {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tries {
          id
          trier {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tags
        frames {
          id
          colors
          duration
        }
        plainFrames
        displayColors
        creationDate
        projectCode
        type
        searchData
        privateTitle
        sharedToHome
        reported
        username
        avatarName
        owner
        categoryLevel
        category
        level
        tryCount
        isAnimation
        isFeatured
        isAnimationLevel
        isFeaturedLevel
        createdFromWebApp
        updatedFromWebApp
      }
      nextToken
    }
  }
`;
export const listProjectsByLevelOldestFirst = /* GraphQL */ `
  query ListProjectsByLevelOldestFirst(
    $level: Int
    $filter: TableProjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProjectsByLevelOldestFirst(
      level: $level
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        creator {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        background
        border
        comments {
          id
          creator {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          text
          reported
          creationDate
        }
        likes {
          id
          liker {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tries {
          id
          trier {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tags
        frames {
          id
          colors
          duration
        }
        plainFrames
        displayColors
        creationDate
        projectCode
        type
        searchData
        privateTitle
        sharedToHome
        reported
        username
        avatarName
        owner
        categoryLevel
        category
        level
        tryCount
        isAnimation
        isFeatured
        isAnimationLevel
        isFeaturedLevel
        createdFromWebApp
        updatedFromWebApp
      }
      nextToken
    }
  }
`;
export const listProjectsByLevelMostTriedFirst = /* GraphQL */ `
  query ListProjectsByLevelMostTriedFirst(
    $level: Int
    $filter: TableProjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProjectsByLevelMostTriedFirst(
      level: $level
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        creator {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        background
        border
        comments {
          id
          creator {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          text
          reported
          creationDate
        }
        likes {
          id
          liker {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tries {
          id
          trier {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tags
        frames {
          id
          colors
          duration
        }
        plainFrames
        displayColors
        creationDate
        projectCode
        type
        searchData
        privateTitle
        sharedToHome
        reported
        username
        avatarName
        owner
        categoryLevel
        category
        level
        tryCount
        isAnimation
        isFeatured
        isAnimationLevel
        isFeaturedLevel
        createdFromWebApp
        updatedFromWebApp
      }
      nextToken
    }
  }
`;
export const listProjectsByCategoryLevel = /* GraphQL */ `
  query ListProjectsByCategoryLevel(
    $categoryLevel: String
    $filter: TableProjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProjectsByCategoryLevel(
      categoryLevel: $categoryLevel
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        creator {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        background
        border
        comments {
          id
          creator {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          text
          reported
          creationDate
        }
        likes {
          id
          liker {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tries {
          id
          trier {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tags
        frames {
          id
          colors
          duration
        }
        plainFrames
        displayColors
        creationDate
        projectCode
        type
        searchData
        privateTitle
        sharedToHome
        reported
        username
        avatarName
        owner
        categoryLevel
        category
        level
        tryCount
        isAnimation
        isFeatured
        isAnimationLevel
        isFeaturedLevel
        createdFromWebApp
        updatedFromWebApp
      }
      nextToken
    }
  }
`;
export const listProjectsByCategoryLevelOldestFirst = /* GraphQL */ `
  query ListProjectsByCategoryLevelOldestFirst(
    $categoryLevel: String
    $filter: TableProjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProjectsByCategoryLevelOldestFirst(
      categoryLevel: $categoryLevel
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        creator {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        background
        border
        comments {
          id
          creator {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          text
          reported
          creationDate
        }
        likes {
          id
          liker {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tries {
          id
          trier {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tags
        frames {
          id
          colors
          duration
        }
        plainFrames
        displayColors
        creationDate
        projectCode
        type
        searchData
        privateTitle
        sharedToHome
        reported
        username
        avatarName
        owner
        categoryLevel
        category
        level
        tryCount
        isAnimation
        isFeatured
        isAnimationLevel
        isFeaturedLevel
        createdFromWebApp
        updatedFromWebApp
      }
      nextToken
    }
  }
`;
export const listProjectsByCategoryLevelMostTriedFirst = /* GraphQL */ `
  query ListProjectsByCategoryLevelMostTriedFirst(
    $categoryLevel: String
    $filter: TableProjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProjectsByCategoryLevelMostTriedFirst(
      categoryLevel: $categoryLevel
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        creator {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        background
        border
        comments {
          id
          creator {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          text
          reported
          creationDate
        }
        likes {
          id
          liker {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tries {
          id
          trier {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tags
        frames {
          id
          colors
          duration
        }
        plainFrames
        displayColors
        creationDate
        projectCode
        type
        searchData
        privateTitle
        sharedToHome
        reported
        username
        avatarName
        owner
        categoryLevel
        category
        level
        tryCount
        isAnimation
        isFeatured
        isAnimationLevel
        isFeaturedLevel
        createdFromWebApp
        updatedFromWebApp
      }
      nextToken
    }
  }
`;
export const getSuperpowers = /* GraphQL */ `
  query GetSuperpowers($type: String!) {
    getSuperpowers(type: $type) {
      id
      type
      name
      numberOfRecipients
    }
  }
`;
export const getSearchResults = /* GraphQL */ `
  query GetSearchResults($searchTerm: String, $from: Int, $size: Int) {
    getSearchResults(searchTerm: $searchTerm, from: $from, size: $size) {
      id
      creator {
        id
        username
        dateOfBirth
        email
        subscribedToEmails
        phone
        age
        avatarName
        bio
        hasConnectedImagiCharm
        reported
        participatedIn30DayChallenge
        lastCompletedEpisode
        specialBadges
        specialUserAttributes {
          id
          name
          dateReceived
          isFrame
          type
          seen
        }
        notificationToken
        creationDate
        lastNotificationSeen
        tipsSeen {
          id
          name
          dateSeen
        }
        isInternalUser
        firstConnectedToImagiCharm
        lastConnectedToImagiCharm
        commentsPosted
        tryCount
        sharedProjectsCount
        tryCodeCount
        episodeCodes {
          title
          code
        }
        firmwareVersion
      }
      background
      border
      comments {
        id
        creator {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        text
        reported
        creationDate
      }
      likes {
        id
        liker {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        creationDate
      }
      tries {
        id
        trier {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        creationDate
      }
      tags
      frames {
        id
        colors
        duration
      }
      plainFrames
      displayColors
      creationDate
      projectCode
      type
      searchData
      privateTitle
      sharedToHome
      reported
      username
      avatarName
      owner
      categoryLevel
      category
      level
      tryCount
      isAnimation
      isFeatured
      isAnimationLevel
      isFeaturedLevel
      createdFromWebApp
      updatedFromWebApp
    }
  }
`;
export const getExploreLink = /* GraphQL */ `
  query GetExploreLink($type: String) {
    getExploreLink(type: $type) {
      id
      type
      hyperlink
      imageURL
      imageURLAndroid
      inUse
    }
  }
`;
export const listProjectsByFeaturedBooleanCategory = /* GraphQL */ `
  query ListProjectsByFeaturedBooleanCategory(
    $filter: TableProjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProjectsByFeaturedBooleanCategory(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        creator {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        background
        border
        comments {
          id
          creator {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          text
          reported
          creationDate
        }
        likes {
          id
          liker {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tries {
          id
          trier {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tags
        frames {
          id
          colors
          duration
        }
        plainFrames
        displayColors
        creationDate
        projectCode
        type
        searchData
        privateTitle
        sharedToHome
        reported
        username
        avatarName
        owner
        categoryLevel
        category
        level
        tryCount
        isAnimation
        isFeatured
        isAnimationLevel
        isFeaturedLevel
        createdFromWebApp
        updatedFromWebApp
      }
      nextToken
    }
  }
`;
export const listProjectsByFeaturedBooleanCategoryOldestFirst = /* GraphQL */ `
  query ListProjectsByFeaturedBooleanCategoryOldestFirst(
    $filter: TableProjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProjectsByFeaturedBooleanCategoryOldestFirst(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        creator {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        background
        border
        comments {
          id
          creator {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          text
          reported
          creationDate
        }
        likes {
          id
          liker {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tries {
          id
          trier {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tags
        frames {
          id
          colors
          duration
        }
        plainFrames
        displayColors
        creationDate
        projectCode
        type
        searchData
        privateTitle
        sharedToHome
        reported
        username
        avatarName
        owner
        categoryLevel
        category
        level
        tryCount
        isAnimation
        isFeatured
        isAnimationLevel
        isFeaturedLevel
        createdFromWebApp
        updatedFromWebApp
      }
      nextToken
    }
  }
`;
export const listProjectsByFeaturedBooleanCategoryMostTriedFirst = /* GraphQL */ `
  query ListProjectsByFeaturedBooleanCategoryMostTriedFirst(
    $filter: TableProjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProjectsByFeaturedBooleanCategoryMostTriedFirst(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        creator {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        background
        border
        comments {
          id
          creator {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          text
          reported
          creationDate
        }
        likes {
          id
          liker {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tries {
          id
          trier {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tags
        frames {
          id
          colors
          duration
        }
        plainFrames
        displayColors
        creationDate
        projectCode
        type
        searchData
        privateTitle
        sharedToHome
        reported
        username
        avatarName
        owner
        categoryLevel
        category
        level
        tryCount
        isAnimation
        isFeatured
        isAnimationLevel
        isFeaturedLevel
        createdFromWebApp
        updatedFromWebApp
      }
      nextToken
    }
  }
`;
export const listProjectsByAnimationBooleanCategory = /* GraphQL */ `
  query ListProjectsByAnimationBooleanCategory(
    $filter: TableProjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProjectsByAnimationBooleanCategory(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        creator {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        background
        border
        comments {
          id
          creator {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          text
          reported
          creationDate
        }
        likes {
          id
          liker {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tries {
          id
          trier {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tags
        frames {
          id
          colors
          duration
        }
        plainFrames
        displayColors
        creationDate
        projectCode
        type
        searchData
        privateTitle
        sharedToHome
        reported
        username
        avatarName
        owner
        categoryLevel
        category
        level
        tryCount
        isAnimation
        isFeatured
        isAnimationLevel
        isFeaturedLevel
        createdFromWebApp
        updatedFromWebApp
      }
      nextToken
    }
  }
`;
export const listProjectsByAnimationBooleanCategoryOldestFirst = /* GraphQL */ `
  query ListProjectsByAnimationBooleanCategoryOldestFirst(
    $filter: TableProjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProjectsByAnimationBooleanCategoryOldestFirst(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        creator {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        background
        border
        comments {
          id
          creator {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          text
          reported
          creationDate
        }
        likes {
          id
          liker {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tries {
          id
          trier {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tags
        frames {
          id
          colors
          duration
        }
        plainFrames
        displayColors
        creationDate
        projectCode
        type
        searchData
        privateTitle
        sharedToHome
        reported
        username
        avatarName
        owner
        categoryLevel
        category
        level
        tryCount
        isAnimation
        isFeatured
        isAnimationLevel
        isFeaturedLevel
        createdFromWebApp
        updatedFromWebApp
      }
      nextToken
    }
  }
`;
export const listProjectsByAnimationBooleanCategoryMostTriedFirst = /* GraphQL */ `
  query ListProjectsByAnimationBooleanCategoryMostTriedFirst(
    $filter: TableProjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProjectsByAnimationBooleanCategoryMostTriedFirst(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        creator {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        background
        border
        comments {
          id
          creator {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          text
          reported
          creationDate
        }
        likes {
          id
          liker {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tries {
          id
          trier {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tags
        frames {
          id
          colors
          duration
        }
        plainFrames
        displayColors
        creationDate
        projectCode
        type
        searchData
        privateTitle
        sharedToHome
        reported
        username
        avatarName
        owner
        categoryLevel
        category
        level
        tryCount
        isAnimation
        isFeatured
        isAnimationLevel
        isFeaturedLevel
        createdFromWebApp
        updatedFromWebApp
      }
      nextToken
    }
  }
`;
export const listProjectsByAnimationLevel = /* GraphQL */ `
  query ListProjectsByAnimationLevel(
    $animationLevel: String
    $filter: TableProjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProjectsByAnimationLevel(
      animationLevel: $animationLevel
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        creator {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        background
        border
        comments {
          id
          creator {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          text
          reported
          creationDate
        }
        likes {
          id
          liker {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tries {
          id
          trier {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tags
        frames {
          id
          colors
          duration
        }
        plainFrames
        displayColors
        creationDate
        projectCode
        type
        searchData
        privateTitle
        sharedToHome
        reported
        username
        avatarName
        owner
        categoryLevel
        category
        level
        tryCount
        isAnimation
        isFeatured
        isAnimationLevel
        isFeaturedLevel
        createdFromWebApp
        updatedFromWebApp
      }
      nextToken
    }
  }
`;
export const listProjectsByAnimationLevelOldestFirst = /* GraphQL */ `
  query ListProjectsByAnimationLevelOldestFirst(
    $animationLevel: String
    $filter: TableProjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProjectsByAnimationLevelOldestFirst(
      animationLevel: $animationLevel
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        creator {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        background
        border
        comments {
          id
          creator {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          text
          reported
          creationDate
        }
        likes {
          id
          liker {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tries {
          id
          trier {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tags
        frames {
          id
          colors
          duration
        }
        plainFrames
        displayColors
        creationDate
        projectCode
        type
        searchData
        privateTitle
        sharedToHome
        reported
        username
        avatarName
        owner
        categoryLevel
        category
        level
        tryCount
        isAnimation
        isFeatured
        isAnimationLevel
        isFeaturedLevel
        createdFromWebApp
        updatedFromWebApp
      }
      nextToken
    }
  }
`;
export const listProjectsByAnimationLevelMostTriedFirst = /* GraphQL */ `
  query ListProjectsByAnimationLevelMostTriedFirst(
    $animationLevel: String
    $filter: TableProjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProjectsByAnimationLevelMostTriedFirst(
      animationLevel: $animationLevel
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        creator {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        background
        border
        comments {
          id
          creator {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          text
          reported
          creationDate
        }
        likes {
          id
          liker {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tries {
          id
          trier {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tags
        frames {
          id
          colors
          duration
        }
        plainFrames
        displayColors
        creationDate
        projectCode
        type
        searchData
        privateTitle
        sharedToHome
        reported
        username
        avatarName
        owner
        categoryLevel
        category
        level
        tryCount
        isAnimation
        isFeatured
        isAnimationLevel
        isFeaturedLevel
        createdFromWebApp
        updatedFromWebApp
      }
      nextToken
    }
  }
`;
export const listProjectsByFeaturedLevel = /* GraphQL */ `
  query ListProjectsByFeaturedLevel(
    $featuredLevel: String
    $filter: TableProjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProjectsByFeaturedLevel(
      featuredLevel: $featuredLevel
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        creator {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        background
        border
        comments {
          id
          creator {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          text
          reported
          creationDate
        }
        likes {
          id
          liker {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tries {
          id
          trier {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tags
        frames {
          id
          colors
          duration
        }
        plainFrames
        displayColors
        creationDate
        projectCode
        type
        searchData
        privateTitle
        sharedToHome
        reported
        username
        avatarName
        owner
        categoryLevel
        category
        level
        tryCount
        isAnimation
        isFeatured
        isAnimationLevel
        isFeaturedLevel
        createdFromWebApp
        updatedFromWebApp
      }
      nextToken
    }
  }
`;
export const listProjectsByFeaturedLevelOldestFirst = /* GraphQL */ `
  query ListProjectsByFeaturedLevelOldestFirst(
    $featuredLevel: String
    $filter: TableProjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProjectsByFeaturedLevelOldestFirst(
      featuredLevel: $featuredLevel
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        creator {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        background
        border
        comments {
          id
          creator {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          text
          reported
          creationDate
        }
        likes {
          id
          liker {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tries {
          id
          trier {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tags
        frames {
          id
          colors
          duration
        }
        plainFrames
        displayColors
        creationDate
        projectCode
        type
        searchData
        privateTitle
        sharedToHome
        reported
        username
        avatarName
        owner
        categoryLevel
        category
        level
        tryCount
        isAnimation
        isFeatured
        isAnimationLevel
        isFeaturedLevel
        createdFromWebApp
        updatedFromWebApp
      }
      nextToken
    }
  }
`;
export const listProjectsByFeaturedLevelMostTriedFirst = /* GraphQL */ `
  query ListProjectsByFeaturedLevelMostTriedFirst(
    $featuredLevel: String
    $filter: TableProjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProjectsByFeaturedLevelMostTriedFirst(
      featuredLevel: $featuredLevel
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        creator {
          id
          username
          dateOfBirth
          email
          subscribedToEmails
          phone
          age
          avatarName
          bio
          hasConnectedImagiCharm
          reported
          participatedIn30DayChallenge
          lastCompletedEpisode
          specialBadges
          specialUserAttributes {
            id
            name
            dateReceived
            isFrame
            type
            seen
          }
          notificationToken
          creationDate
          lastNotificationSeen
          tipsSeen {
            id
            name
            dateSeen
          }
          isInternalUser
          firstConnectedToImagiCharm
          lastConnectedToImagiCharm
          commentsPosted
          tryCount
          sharedProjectsCount
          tryCodeCount
          episodeCodes {
            title
            code
          }
          firmwareVersion
        }
        background
        border
        comments {
          id
          creator {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          text
          reported
          creationDate
        }
        likes {
          id
          liker {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tries {
          id
          trier {
            id
            username
            dateOfBirth
            email
            subscribedToEmails
            phone
            age
            avatarName
            bio
            hasConnectedImagiCharm
            reported
            participatedIn30DayChallenge
            lastCompletedEpisode
            specialBadges
            specialUserAttributes {
              id
              name
              dateReceived
              isFrame
              type
              seen
            }
            notificationToken
            creationDate
            lastNotificationSeen
            tipsSeen {
              id
              name
              dateSeen
            }
            isInternalUser
            firstConnectedToImagiCharm
            lastConnectedToImagiCharm
            commentsPosted
            tryCount
            sharedProjectsCount
            tryCodeCount
            episodeCodes {
              title
              code
            }
            firmwareVersion
          }
          creationDate
        }
        tags
        frames {
          id
          colors
          duration
        }
        plainFrames
        displayColors
        creationDate
        projectCode
        type
        searchData
        privateTitle
        sharedToHome
        reported
        username
        avatarName
        owner
        categoryLevel
        category
        level
        tryCount
        isAnimation
        isFeatured
        isAnimationLevel
        isFeaturedLevel
        createdFromWebApp
        updatedFromWebApp
      }
      nextToken
    }
  }
`;
